import api from './api';
import { Node, Edge } from 'reactflow';
import { GraphData, GraphFilter } from '../types/graph';

export async function getSessionGraph(sessionId: string): Promise<GraphData> {
  const response = await api.get(`/sessions/${sessionId}/graph`);
  return response.data;
}

export async function saveGraphLayout(sessionId: string, nodes: Node[], edges: Edge[]): Promise<void> {
  await api.post(`/sessions/${sessionId}/graph/layout`, { nodes, edges });
}

export async function expandNode(nodeId: string, nodeType: string): Promise<GraphData> {
  const response = await api.get(`/graph/expand`, {
    params: { nodeId, nodeType }
  });
  return response.data;
}

export async function getLineageGraph(rootUid: string): Promise<GraphData> {
  const response = await api.get(`/lineage/${rootUid}/graph`);
  return response.data;
}

export async function filterGraph(
  sessionId: string, 
  filter: GraphFilter
): Promise<GraphData> {
  const response = await api.get(`/sessions/${sessionId}/graph/filter`, {
    params: filter
  });
  return response.data;
}

export async function exportGraphAsImage(
  sessionId: string, 
  format: 'png' | 'svg' | 'jpg' = 'png'
): Promise<string> {
  const response = await api.get(`/sessions/${sessionId}/graph/export`, {
    params: { format },
    responseType: 'blob'
  });
  
  return URL.createObjectURL(response.data);
}

export async function importGraphLayout(
  sessionId: string, 
  layoutFile: File
): Promise<GraphData> {
  const formData = new FormData();
  formData.append('layout', layoutFile);
  
  const response = await api.post(`/sessions/${sessionId}/graph/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
}
